<template>
    <div class='content'>
        <div class="con-1">
            <div class="con-2">{{ $t('content108') }}</div>
            <div class="con-3">
                {{ $t('content109') }}</div>
            <img :src="$i18n.locale == 'zh' ? require('@/assets/fangda1.png'):require('@/assets/en_yongjin_banner.png')" class="con-3-img" alt="">
        </div>

        <div>
            <div class="con-5">
                <div class="con-6">{{ $t('content110') }}</div>
                <div class="con-7">
                    {{ $t('content111') }}
                </div>
                <div class="con-8">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content112') }}</div>
                </div>
                <div class="con-10">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content113') }}</div>
                </div>
                <div class="con-10">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">
                        {{ $t('content114') }}</div>
                </div>
            </div>
            <div>
                <img :src="$i18n.locale == 'zh' ? require('@/assets/wuguojie_img@2x.png'):require('@/assets/en_wuguojie_img.png')" class="con-11-img" alt="">
            </div>
        </div>

        <div>
            <div class="con-13">
                <div class="con-14">{{ $t('content115') }}</div>
                <div class="con-8">

                    <div class="con-9-txt">
                        {{ $t('content116') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content117') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content118') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content119') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content120') }}</div>
                </div>
            </div>
            <div class="con-12">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 30@2x.png'):require('@/assets/en_Slice 30.png')" class="con-12-img" alt="">
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_1',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.content{
  padding-top: 290px;
}
.con-1 {
    position: relative;
}

.con-2 {
    font-size: 82px;
    color: #333;
    text-align: center;
}

.con-3 {
    font-size: 72px;
    color: #666666;
    text-align: center;
    padding-bottom: 47px;
    margin-top: 50px;
    width: 1800px;
}

.con-3-img {
    width: 100%;
    height: 100%;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 435px;
    left: 360px;
}


.con-15 {
    display: flex;
    align-items: center;
    margin-top: 50px;
}

.con-5 {
    padding: 47px;
}

.con-6 {
    font-size: 82px;
    color: #333333;
    margin-bottom: 34px;
    font-weight: 600;
}


.con-12-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.con-13 {
    margin-top: 50px;
}

.con-14 {
    font-size: 82px;
    color: #333333;
    margin-bottom: 50px;
    text-align: center;
    font-weight: 600;
}

.con-8 {
    display: flex;
    align-items: center;
    /* padding: 47px; */
}

.con-8-img {
    width: 60px;
    height: 60px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;

}



.con-7 {
    font-size: 72px;
    color: #949697;
    margin-bottom: 50px;
    margin-top: 50px;
    line-height: 120px;
}

.con-10 {
    display: flex;
    align-items: center;
    margin-top: 50px;
}



.con-11-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;
    cursor: pointer;



}

.con-9 {
    font-size: 72px;
    color: #333333;
    margin-left: 12px;
}

.con-9-txt {
    font-size: 72px;
    color: #666666;
    margin-top: 50px;
    line-height: 120px;
    /* 
    width: 555px; */
}
</style>